import axios from 'axios';

// Create a single axios instance for reuse
const api = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add response caching
const cache = new Map();

export const fetchWithCache = async (url, params = {}, cacheTime = 5 * 60 * 1000) => {
  const cacheKey = url + JSON.stringify(params);
  
  // Check if we have a valid cached response
  if (cache.has(cacheKey)) {
    const cachedData = cache.get(cacheKey);
    if (Date.now() - cachedData.timestamp < cacheTime) {
      return cachedData.data;
    }
  }
  
  // If no cache or expired, make the request
  const response = await api.get(url, { params });
  
  // Cache the response
  cache.set(cacheKey, {
    data: response.data,
    timestamp: Date.now()
  });
  
  return response.data;
};

// Batch multiple API requests
export const batchRequests = async (requests) => {
  return Promise.all(requests.map(req => {
    if (typeof req === 'function') {
      return req();
    }
    return api.get(req);
  }));
};

export default api;